BillingFormUtil = require '../internal/billing-form-util'
BraintreeGateway = require './internal/braintree-gateway'
CVVTooltipView = require 'views/billing/form-sections/cvv-tooltip-content'
FormFields = require './internal/form-fields'
React = require 'react'
Tooltip = require 'views/lib/tooltip'
t = require('views/internal/recup-with-helpers')('credit_card')
track = require 'debug/track'

gatewayField = ({
  fieldType
  formatError
  gatewayFocusField
  gatewayLoaded
  isInvalid
  labelKey
  selector
}) ->

  t.label ->
    t.span "#{ selector }-label-text", ->
      t.format labelKey
    t.div ".iframe-input#{ selector }", class:
      t.classify
        disabled: !gatewayLoaded
        focus: gatewayFocusField == fieldType
        'input-error': isInvalid
    if formatError? && isInvalid
      t.span '.u-form-error', ->
        formatError()

module.exports = class extends React.Component
  displayName: 'CreditCardComponent'

  formFields: []
  requiredFields: {}

  render: t.renderable ->
    renderForm = =>
      renderBraintree = ({ braintreeState }) =>
        {
          cardType
          gatewayFieldStatus
          gatewayFocusField
          gatewayLoaded
          niceCardType
        } = braintreeState

        @requiredFields.number = => !BillingFormUtil.isUnsupportedCardType cardType

        tooltipClickHandler = ->
          if document.querySelectorAll('.js-tooltip-content').length
            Tooltip.hide()
          else
            track 'Organization View', 'Business Class Page', 'CVV Tooltip'

            tooltipHtml = new CVVTooltipView
              cardType: cardType

            $btn = @$('.js-cvv-tooltip-trigger')
            Tooltip.show(
              tooltipHtml,
              $btn,
              false,
              Tooltip.STYLE.BILLING
            )

        t.div '.u-clearfix', ->
          t.form { @onSubmit, ref: 'form' }, ->
            t.h3 ->
              t.format 'pay-with-credit-card'

            t.div '.credit-card-form-section', ->
              t.div '.u-clearfix', ->
                t.div '.credit-card-form-number', ->
                  gatewayField {
                    fieldType: 'number'
                    formatError: BillingFormUtil.getCardErrorFormatter cardType, niceCardType
                    gatewayFocusField
                    gatewayLoaded
                    isInvalid: gatewayFieldStatus['number'] == 'invalid' || BillingFormUtil.isUnsupportedCardType cardType
                    labelKey: 'credit-card'
                    selector: '.js-card-number' + (if cardType then '.' + cardType else '')
                  }

                t.div '.credit-card-expiration-date', ->
                  gatewayField {
                    errorKey: 'please-provide-a-valid-expiration-date'
                    fieldType: 'expirationDate'
                    formatError: -> t.format 'please-provide-a-valid-expiration-date'
                    gatewayFocusField
                    gatewayLoaded
                    isInvalid: gatewayFieldStatus['expirationDate'] == 'invalid'
                    labelKey: 'expiration-date'
                    selector: '.js-expiration-date'
                  }

                t.div '.credit-card-form-cvv', ->
                  gatewayField {
                    errorKey: BillingFormUtil.getCvvErrorKey(cardType)
                    fieldType: 'cvv'
                    formatError: -> t.format BillingFormUtil.getCvvErrorKey(cardType)
                    gatewayFocusField
                    gatewayLoaded
                    isInvalid: gatewayFieldStatus['cvv'] == 'invalid'
                    labelKey: 'cvv'
                    selector: '.js-cvv'
                  }

                  t.span '.cvv-tooltip-trigger.js-cvv-tooltip-trigger', onClick: tooltipClickHandler

      t.tag BraintreeGateway, {
        ref: (braintree) => @braintree = braintree
        render: renderBraintree
      }

    t.tag FormFields, {
      render: renderForm
      ref: (formFieldsRef) => @formFieldsRef = formFieldsRef
      @formFields
      @requiredFields
      initialState: {}
      getAsyncData: => @braintree.getAsyncData()
    }

  onSubmit: (e) ->
    e.preventDefault()



// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/credit-card-component.coffee